<div class="input-group input-group-sm pe-0 pe-md-3  w-100">
  <input [(ngModel)]="term" (ngModelChange)="search()" type="text" class="form-control form-control-sm"
    placeholder="Filter by IATA, City, Country, Company…" />
  <button class=" btn btn-light" type="button" [disabled]="!term" (click)="clearTerm()">
    <i class="fas fa-times"></i>
  </button>
</div>